import { make } from 'vuex-pathify'

export default {
    mutations: (stateObject) => {
        return {
            ...make.mutations(stateObject),

            RESET(state) {
                Object.assign(state, stateObject)
            }
        }
    }
}
